
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import Paginator from 'primevue/paginator';
import IftaLabel from 'primevue/iftalabel';
import Card from 'primevue/card';
import Button from 'primevue/button';
import Tag from 'primevue/tag';
import DatePicker from 'primevue/datepicker';
import ProgressSpinner from 'primevue/progressspinner';

import { onMounted, ref, watch, computed } from 'vue';
import { affiliate } from '../apis/affiliate';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import PopupAffiliateNavbar from '../components/navbar/PopupAffiliateNavbar.vue';
import { useToast } from 'primevue/usetoast';
import { formatCurrency } from '../utils/currency';

export default {
	name: 'AffiliateReport',
	methods: { formatCurrency },
	components: {
		DataTable,
		Column,
		ColumnGroup,
		Row,
		Paginator,
		IftaLabel,
		Tag,
		DatePicker,
		ProgressSpinner,
		Card,
		Button,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);
		const toast = useToast();

		const tableLoading = ref(false);

		const form = ref({
			dates: [] as Date[],
			btn: {
				loading: false,
			},
		});

		const first = ref(0);
		const rows = ref(10);

		// ✅ ใช้เป็น object เพื่อเก็บทั้ง records + total
		const reports = ref({
			records: [],
			totalRecord: 0,
		});

		const totalRecords = computed(() => reports.value.totalRecord || 0);

		const formatDate = (date: Date): string => {
			return date.toISOString().split('T')[0];
		};

		const handleReportTransaction = async () => {
			tableLoading.value = true;

			const page = Math.floor(first.value / rows.value) + 1;
			const start = form.value.dates?.[0] ? formatDate(new Date(form.value.dates[0])) : formatDate(new Date());
			const end = form.value.dates?.[1] ? formatDate(new Date(form.value.dates[1])) : formatDate(new Date());

			const payload = {
				startDate: start,
				endDate: end,
				page: page,
				size: rows.value,
			};

			try {
				const resp = await affiliate.reportTarnsection(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				reports.value = {
					records: resp.result?.records || [],
					totalRecord: resp.result?.totalRecord || 0,
				};
			} catch (error) {
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาดบางอย่าง',
					detail: String(error),
					life: 3000,
				});
			} finally {
				tableLoading.value = false;
			}
		};

		const onPageChange = (event: any) => {
			first.value = event.first;
			rows.value = event.rows;
		};

		const handleSearch = async () => {
			form.value.btn.loading = true;
			first.value = 0;
			try {
				await handleReportTransaction();
			} catch (error) {
				toast.add({
					severity: 'error',
					summary: 'เกิดข้อผิดพลาดบางอย่าง',
					detail: String(error),
					life: 3000,
				});
			} finally {
				form.value.btn.loading = false;
			}
		};

		onMounted(() => {
			const today = new Date();
			form.value.dates = [today, today];
			handleReportTransaction();
		});

		watch([first, rows], () => {
			handleReportTransaction();
		});

		return {
			profile,
			tableLoading,
			form,
			reports,
			first,
			rows,
			totalRecords,
			onPageChange,
			handleSearch,
		};
	},
};
